module.exports = __webpack_public_path__ + "static/media/qatarlog.cef50106.png";